<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <div id="square7" class="square square-7" style="transform: perspective(500px) rotateY(11.45deg) rotateX(0.123333deg);"></div>
        <div id="square8" class="square square-8" style="transform: perspective(500px) rotateY(11.45deg) rotateX(0.123333deg);"></div>
        <div class="card card-register">
          <div class="card-header">
            <img class="card-img" src="../assets/img/square1.png" alt="Card image" title="" style="">
            <h4 class="card-title">Log in</h4>
          </div>
          <form class="form" @submit.prevent="submit">
            <div class="card-body">
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <i class="ion ion-md-person"></i>
                  </div>
                </div>
                <input type="text" placeholder="Username" class="form-control" v-model="username">
              </div>
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <i class="ion ion-md-lock"></i>
                  </div>
                </div>
                <input type="password" class="form-control" placeholder="Password" v-model="password">
              </div>
            </div>
            <div class="card-footer d-flex justify-content-between align-items-center">
              <button type="submit" href="javascript:void(0)" @click.prevent="submit" class="btn btn-info btn-round btn-lg">Log in</button>
              <router-link :to="{name: 'resetpassword'}">Forgot Password?</router-link>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="register-bg"></div>
    <div id="square1" class="square square-1" style="transform: perspective(500px) rotateY(28.625deg) rotateX(0.308333deg);"></div>
    <div id="square2" class="square square-2" style="transform: perspective(500px) rotateY(28.625deg) rotateX(0.308333deg);"></div>
    <div id="square3" class="square square-3" style="transform: perspective(500px) rotateY(28.625deg) rotateX(0.308333deg);"></div>
    <div id="square4" class="square square-4" style="transform: perspective(500px) rotateY(28.625deg) rotateX(0.308333deg);"></div>
    <div id="square5" class="square square-5" style="transform: perspective(500px) rotateY(28.625deg) rotateX(0.308333deg);"></div>
    <div id="square6" class="square square-6" style="transform: perspective(500px) rotateY(28.625deg) rotateX(0.308333deg);"></div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: ''
    }
  },
  methods: {
    submit () {
      this.$store.dispatch('users/loginUser', {username: this.username, password: this.password})
    }
  }
}
</script>
